import { observable, action, autorun } from 'mobx';
import { setter, toggle } from 'mobx-decorators';
import agent from '../../services/web/agent';
import erorrHandler from '../../services/web/erorrHandler';
import validator from './validator';
import translationsStore from '../translationsStore';

class SAMLStore {

    @setter @observable samlIdentityProviders;
    @setter @observable selectedTabId = 1;
    @setter @toggle @observable isEditMode = false;

    @setter @observable getAllSAMLIdpsProgress;
    @setter @observable getSAMLIdpProgress;
    @setter @observable postSAMLIdpsProgress;
    @setter @observable putSAMLIdpsProgress;
    @setter @observable deleteSAMLIdpsProgress;

    @setter @observable getAllSAMLIdpsErrorMessage;
    @setter @observable getSAMLIdpErrorMessage;
    @setter @observable postSAMLIdpErrorMessage;
    @setter @observable putSAMLIdpErrorMessage;
    @setter @observable deleteSAMLIdpsErrorMessage;

    // model
    @setter @observable id;
    @setter @observable certificateFile;
    @setter @observable certificateFileName;
    @setter @observable certificateSubject;
    @setter @observable active = true;
    @setter @observable issuer;
    @setter @observable name;
    @setter @observable loginUrl;
    @setter @observable logoutUrl;
    @setter @observable errorUrl;
    @setter @observable signAuthnRequest = false;
    @setter @observable authnRequestBinding;
    @setter @observable isManualManagement = true;
    @setter @observable defaultTeamId;
    @setter @observable defaultRoleId = '';

    @setter @observable isMappingEnabled = false;
    @setter @observable roleMappingAttribute = '';
    @setter @observable teamMappingAttribute = '';


    unassignedRequestBindingId = -1;


    constructor() {
        this.validator = validator;
        this.resetForm();
    }

    @action getAllSAMLIdentityProviders() {
        
        this.getAllSAMLIdpsProgress = true;

        return agent.SamlIdentityProviders.getAllSAMLIdentityProviders()
            .then(action(samlIdentityProviders => this.samlIdentityProviders = samlIdentityProviders))
            .catch(action(err => {

                this.getAllSAMLIdpsErrorMessage = erorrHandler.getErrorMessage(err);
            
                throw err;
            }))
            .finally(action(_ => {

                this.getAllSAMLIdpsProgress = false;
            }));
    }

    @action getSAMLIdentityProvider(idpId) {
        
        this.getSAMLIdpProgress = true;

        return agent.SamlIdentityProviders.getSAMLIdentityProvider(idpId)
            .then(action(samlIdentityProvider => {

                return samlIdentityProvider;
            }))
            .catch(action(err => {

                this.getSAMLIdpErrorMessage = erorrHandler.getErrorMessage(err);
            
                throw err;
            }))
            .finally(action(_ => {

                this.getSAMLIdpProgress = false;
            }));
    }

    @action deleteSAMLIdentityProvider(idpId) {

        this.deleteSAMLIdpsProgress = true;

        return agent.SamlIdentityProviders.deleteSAMLIdentityProvider(idpId)
            .then(action(_ => {

            }))
            .catch(action(err => {

                this.deleteSAMLIdpsErrorMessage = erorrHandler.getErrorMessage(err);
            
                throw err;
            }))
            .finally(action(_ => {

                this.deleteSAMLIdpsProgress = false;
            }));
    }

    @action post() {

        this.postSAMLIdpsProgress = true;

        return agent.SamlIdentityProviders.post(this.getModel())
            .then(action(_ => {}))
            .catch(action(err => {

                this.postSAMLIdpErrorMessage = erorrHandler.getErrorMessage(err);
            
                throw err;
            }))
            .finally(action(_ => this.postSAMLIdpsProgress = false));
    }

    @action put() {

        this.putSAMLIdpsProgress = true;

        return agent.SamlIdentityProviders.put(this.id, this.getModel())
            .then(action(_ => {}))
            .catch(action(err => {

                this.putSAMLIdpErrorMessage = erorrHandler.getErrorMessage(err);
            
                throw err;
            }))
            .finally(action(_ => this.putSAMLIdpsProgress = false));
    }

    @action resetForm() {
        this.resetFields();        
        this.validator.resetValidations();
    }
    
    resetFields() {

        this.id = '';
        this.certificateFile = '';
        this.certificateFileName = '';
        this.certificateSubject = '';
        this.active = true;
        this.issuer = '';
        this.name = '';
        this.loginUrl = ''; 
        this.logoutUrl = '';
        this.errorUrl = '';
        this.signAuthnRequest = false;
        this.authnRequestBinding = '';
        this.isManualManagement = true;
        this.defaultTeamId = '';
        this.defaultRoleId = '';
        this.isMappingEnabled = false;
        this.roleMappingAttribute = '';
        this.teamMappingAttribute = '';
    }

    getModel = _ => {

        const roleId = this.defaultRoleId == null || this.defaultRoleId == -1 ? '' : this.defaultRoleId;
        const teamId =  this.defaultTeamId == null || this.defaultTeamId == -1 ? '' : this.defaultTeamId;

        return {
            id: this.id,
            certificateFile: this.certificateFile,
            certificateFileName: this.certificateFileName,
            active: this.active,
            issuer: this.issuer,
            name: this.name,
            loginUrl: this.loginUrl,
            logoutUrl: this.logoutUrl || '',
            errorUrl: this.errorUrl || '',
            signAuthnRequest: this.signAuthnRequest,
            authnRequestBinding: this.authnRequestBinding || '',
            isManualManagement: this.isManualManagement,
            defaultTeamId: teamId,
            defaultRoleId: roleId,
            mapSamlIdpAttributes: this.isMappingEnabled,
            roleMappingAttribute : this.roleMappingAttribute || '',
            teamMappingAttribute : this.teamMappingAttribute || '',
        };
    }

    get authnRequestBindingList() {

        const httpRedirect = 'HTTP-Redirect', httpPost = 'HTTP-Post';

        return [
            {
                id: this.unassignedRequestBindingId,
                name: translationsStore.translate('REQUEST_BINDING')
            },
            {
                id: httpRedirect.toUpperCase(),
                name: httpRedirect
            },
            {
                id: httpPost.toUpperCase(),
                name: httpPost
            }            
        ];
    }
}

export default new SAMLStore();